
import React, { useEffect, useState } from 'react';
import '../App.css';
import Map from '../components/AlertPieChart';
import { useNavigate } from 'react-router-dom';
import MainContent from '../components/MainContent';
import { Box } from '@mui/material';
import { useLazyGetContractListQuery } from '../features/contract/ContractSlice';
import { useTranslation } from "react-i18next";

const AddLocationPage = () => {
    const {t, i18n} = useTranslation();
    // const [getContract, contract] = useLazyGetContractListQuery();
    // const [selectPosition, setTemp] = useState(
    //     {
    //         project_id: 1,
    //         project_name: "Vision Peak Solutions company",
    //         place_id: 1,
    //         name: '太子43123213546',
    //         lat: 22.32538,
    //         lng: 114.18028,
    //         detail: 'location 1',
    //         date: "18/01/2024",
    //         on_site_day: 5
    // });

    // useEffect(() => {
    //     console.log(contract);
    // },[contract])

    // const defaultData = [
    //     { status: "Ongoing Entries", num: 15 },
    //     { status: "Completed Entires", num: 10 },
    //     { status: "Exits", num: 5 }];

    // const navigate = useNavigate();
    return (
        <MainContent type={"Entry"}>
            <Box sx={{ width: "720px" }}>
                <Map />
            </Box>

        </MainContent>
    );
};

export default AddLocationPage;